import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/DashboardSDA',
    name: 'DashboardSDA',
    component: () => import('../views/Dashboard/DashboardSDA.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DashboardBalai',
    name: 'DashboardBalai',
    component: () => import('../views/Dashboard/DashboardBalai.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DashboardDonor',
    name: 'DashboardDonor',
    component: () => import('../views/Dashboard/DashboardDonor.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DashboardLoan',
    name: 'DashboardLoan',
    component: () => import('../views/Dashboard/DashboardLoan.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/',
    name: 'Login',
    component: () => import('../views/Login/Login.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/RekapSDABalai',
    name: 'RekapSDABalai',
    component: () => import('../views/Monitoring/RekapSDABalai.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/RekapLender',
    name: 'RekapLender',
    component: () => import('../views/Monitoring/RekapLender.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/RekapPerProyek',
    name: 'RekapPerProyek',
    component: () => import('../views/Monitoring/RekapPerProyek.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/RekapPerRegister',
    name: 'RekapPerRegister',
    component: () => import('../views/Monitoring/RekapPerRegister.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DetailProgres',
    name: 'DetailProgres',
    component: () => import('../views/Monitoring/DetailProgres.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/PaketSDABalai',
    name: 'PaketSDABalai',
    component: () => import('../views/Kontraktual/RekapSDABalai.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/PaketPerProyek',
    name: 'PaketPerProyek',
    component: () => import('../views/Kontraktual/RekapPerProyek.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DetailPaket',
    name: 'DetailPaket',
    component: () => import('../views/Kontraktual/DetailPaket.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/PrognosisSDABalai',
    name: 'PrognosisSDABalai',
    component: () => import('../views/Prognosis/RekapSDABalai.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/PrognosisLender',
    name: 'PrognosisLender',
    component: () => import('../views/Prognosis/RekapLender.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/PrognosisPerProyek',
    name: 'PrognosisPerProyek',
    component: () => import('../views/Prognosis/RekapPerProyek.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/PrognosisPerRegister',
    name: 'PrognosisPerRegister',
    component: () => import('../views/Prognosis/RekapPerRegister.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/PrognosisProgres',
    name: 'PrognosisProgres',
    component: () => import('../views/Prognosis/DetailPrognosisPaket.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/AWPSDABalai',
    name: 'AWPSDABalai',
    component: () => import('../views/AWP/RekapSDABalai.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/AWPPerProyek',
    name: 'AWPPerProyek',
    component: () => import('../views/AWP/RekapPerProyek.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/AWPDetailBalai',
    name: 'AWPDetailBalai',
    component: () => import('../views/AWP/DetailAWP.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/AWPMapping',
    name: 'AWPMapping',
    component: () => import('../views/AWP/MappingAWP.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/KesalahanPorsi',
    name: 'KesalahanPorsi',
    component: () => import('../views/DIPA/KesalahanPorsi.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/KesalahanKodeBeban',
    name: 'KesalahanKodeBeban',
    component: () => import('../views/DIPA/KesalahanKodeBeban.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/KesalahanKodeKPPN',
    name: 'KesalahanKodeKPPN',
    component: () => import('../views/DIPA/KesalahanKodeKPPN.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/PaketKodeProyekL1',
    name: 'PaketKodeProyekL1',
    component: () => import('../views/DIPA/KesalahanKodeProyekLebihdr1.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/PaketKodeSubPaketL1',
    name: 'PaketKodeSubPaketL1',
    component: () => import('../views/DIPA/KesalahanSubPaketLebihdr1.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DIPAPaketLAWP',
    name: 'DIPAPaketLAWP',
    component: () => import('../views/DIPA/KesalahanPaketLebihdrDIPA.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarPaketKontraktual',
    name: 'DaftarPaketKontraktual',
    component: () => import('../views/DIPA/DaftarPaketKontraktual.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/KendalaSDABalai',
    name: 'KendalaSDABalai',
    component: () => import('../views/Kendala/RekapSDABalai.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/KendalaLender',
    name: 'KendalaLender',
    component: () => import('../views/Kendala/RekapLender.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/KendalaPerProyek',
    name: 'KendalaPerProyek',
    component: () => import('../views/Kendala/RekapPerProyek.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/KendalaProgres',
    name: 'KendalaProgres',
    component: () => import('../views/Kendala/DetailPaket.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/KendalaTindakLanjutPerPaket',
    name: 'KendalaTindakLanjutPerPaket',
    component: () => import('../views/Kendala/DetailProgres.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/FormMappingAWP',
    name: 'FormMappingAWP',
    component: () => import('../views/IsianBalai/DetailAWP.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/PipelineRekapSDABalai',
    name: 'PipelineRekapSDABalai',
    component: () => import('../views/Pipeline/RekapSDABalai.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/PipelineRekapLender',
    name: 'PipelineRekapLender',
    component: () => import('../views/Pipeline/RekapLender.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/PipelineRekapPerProyek',
    name: 'PipelineRekapPerProyek',
    component: () => import('../views/Pipeline/RekapPerProyek.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/PipelineRekapPerRegister',
    name: 'PipelineRekapPerRegister',
    component: () => import('../views/Pipeline/RekapPerRegister.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/PipelineDetailProgres',
    name: 'PipelineDetailProgres',
    component: () => import('../views/Pipeline/DetailProgres.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/KompilasiRegister',
    name: 'KompilasiRegister',
    component: () => import('../views/Kompilasi/KompilasiRegister.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Peta',
    name: 'Peta',
    component: () => import('../views/Peta/Peta.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/OWPAWP',
    name: 'OWPAWP',
    component: () => import('../views/Kompilasi/KompilasiOWPAWP.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ManajemenUser',
    name: 'ManajemenUser',
    component: () => import('../views/User/DataUser.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ManajemenUploadDataEmon',
    name: 'ManajemenUploadDataEmon',
    component: () => import('../views/ManajemenUploadDataEmon/ManajemenUploadDataEmon.vue'),
    meta: {
      transition: "zoom",
    },
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  mode: 'history',
  routes:routes,
  linkActiveClass:'active',
})


router.afterEach((to, from, next) => {
  //console.log(`Navigating to: ${to.name}`);
  if ( to.name == 'Login'){
    //console.log(`Navigating to: ${to.name}`);
  }
  next();
});

export default router;
